import { render, staticRenderFns } from "./LglFiles.vue?vue&type=template&id=832370b0&"
import script from "./LglFiles.vue?vue&type=script&lang=js&"
export * from "./LglFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports